<template>
    <GridBox class="twocol-grid-box">
        <div
            v-if="!isLoadingData && loadedEvent && loadedEvent.rgba"
            :style="`background: linear-gradient(${loadedEvent.rgba} 0%,  rgba(25, 22, 32,0) 100%);`"
            class="gradient-overlay"
        ></div>
        <div
            v-if="!isLoadingData && loadedEvent && loadedEvent.image"
            :style="`background: url(${loadedEvent.image}) no-repeat center center; background-size: cover;`"
            class="img-overlay"
        ></div>
        <GridItem
            size="100%"
            :colidx="computeCol('sm')"
            transparent
            class="m-0 p-0"
        >
            <div
                v-if="!isLoadingData && loadedEvent && loadedEvent.id"
                class="image-lightbox img-card"
            >
                <!-- :style="`background: url(${actualImage}) no-repeat center
                center; background-size: cover;`" -->

                <figure class="event-image">
                    <nuxt-img
                        width="300"
                        height="300"
                        class="img-hero"
                        loading="lazy"
                        :src="loadedEvent.image"
                    />
                </figure>
            </div>
        </GridItem>
        <GridItem size="100%" :colidx="computeCol('lg')" class="content-card">
            <!-- <b-loading
            class="form-loader"
            :is-full-page="false"
            v-model="isLoadingData"
        /> -->

            <GridBody>
                <div
                    class="header"
                    v-if="!isLoadingData && loadedEvent && loadedEvent.id"
                >
                    <!-- <nuxt-link
                        :style="`color:${loadedEvent.backgroundColor} !important`"
                        class="is-size-5 mb-3 has-text-weight-bold is-uppercase"
                        :to="localePath('/events')"
                    >
                        <b-icon icon="fas fa-calendar" />
                        {{ $t("event.back") }}
                    </nuxt-link> -->
                    <button
                        tag="router-link"
                        class="is-uppercase is-size-5 primary-btn is-self-start mb-3"
                        @click="$router.push(localePath('/events'))"
                    >
                        <b-icon
                            size="is-small-icon mr-1"
                            icon="fas fa-calendar"
                        />
                        {{ $t("event.back") }}
                    </button>
                    <h3
                        v-if="
                            loadedEvent.selectedDay ===
                            loadedEvent.selectedEndDay
                        "
                        class="is-size-5 mt-5 mb-1 ml-1 is-primary is-uppercase has-text-weight-bold"
                    >
                        <div class="flex-break">
                            <span>
                                {{ loadedEvent.selectedDay }}

                                {{ loadedEvent.startString }}
                                {{
                                    loadedEvent.category?.value === "courses"
                                        ? ` - ${loadedEvent.endString}`
                                        : ""
                                }}
                            </span>
                        </div>
                    </h3>
                    <h3
                        v-else-if="
                            loadedEvent.selectedDay !==
                            loadedEvent.selectedEndDay
                        "
                        class="is-size-5 mt-5 mb-1 ml-1 is-primary is-uppercase has-text-weight-bold"
                    >
                        <span>
                            {{ loadedEvent.selectedDay }}
                        </span>
                        <span> {{ loadedEvent.startString }} </span>
                        <span v-if="loadedEvent.category?.value === 'courses'">
                            <b-icon
                                icon-pack="fas"
                                class="is-primary-alt"
                                icon="fas fa-arrow-right"
                            />
                        </span>
                        <span v-if="loadedEvent.category?.value === 'courses'">
                            {{ loadedEvent.selectedEndDay }}
                        </span>
                        <span v-if="loadedEvent.category?.value === 'courses'">
                            {{ loadedEvent.endString }}
                        </span>
                    </h3>
                    <div class="flex-between">
                        <div class="title-span">
                            <!-- <div
                                class="is-event-label"
                                :style="
                                    'background:' +
                                    loadedEvent.backgroundColor +
                                    ';'
                                "
                            /> -->
                            <h1
                                class="title m-0 is-size-1 is-uppercase has-text-weight-bold"
                                :style="
                                    'color:' + loadedEvent.backgroundColor + ';'
                                "
                            >
                                {{ loadedEvent.title }}
                            </h1>
                        </div>
                    </div>
                    <div class="flex-between ml-1 mb-5 mt-1">
                        <h3
                            v-if="
                                loadedEvent.category &&
                                loadedEvent.category.name &&
                                loadedEvent.category.nameEn
                            "
                            class="is-cat is-size-6 m-0 is-primary is-uppercase has-text-weight-bold"
                        >
                            in
                            {{
                                this.$i18n.locale === "it"
                                    ? loadedEvent.category.name
                                    : loadedEvent.category.nameEn
                            }}
                        </h3>
                        <div
                            class="total-indicator is-indicator-error"
                            v-if="
                                loadedEvent.paid &&
                                loadedEvent.seats &&
                                loadedEvent.start > new Date().toISOString() &&
                                loadedEvent.seats - loadedEvent.seatsTaken === 0
                            "
                        >
                            <span
                                class="total-label is-size-6 is-uppercase has-text-weight-bold has-text-danger"
                                >{{ $t("event.soldout") }}</span
                            >
                        </div>
                        <div
                            class="total-indicator is-indicator-success"
                            v-if="
                                loadedEvent.paid &&
                                loadedEvent.seats &&
                                loadedEvent.start > new Date().toISOString() &&
                                loadedEvent.seats - loadedEvent.seatsTaken > 0
                            "
                        >
                            <span
                                class="total-label is-size-6 is-uppercase has-text-weight-bold has-text-success"
                            >
                                <ICountUp
                                    v-if="
                                        // loadedEvent.seatsTaken &&
                                        loadedEvent.seats
                                    "
                                    :delay="500"
                                    :startVal="loadedEvent.seats"
                                    :endVal="
                                        loadedEvent.seats -
                                        loadedEvent.seatsTaken
                                    "
                                    :options="seatsOptions"
                                    @ready="onReady"
                                />/{{ loadedEvent.seats }}
                                {{ $t("event.seats") }}</span
                            >
                        </div>
                    </div>

                    <button
                        class="is-uppercase is-size-5 primary-btn is-self-end mb-3"
                        @click="openLink(loadedEvent.link)"
                        target="_blank"
                        v-if="loadedEvent.link"
                    >
                        {{ $t("event.info") }}&nbsp;

                        <b-icon size="is-small-icon mr-1" icon="fas fa-globe" />

                        {{ loadedEvent.linkSlug }}
                    </button>
                </div>

                <div>
                    <!-- <div
                    v-if="
                        this.$config.paymentsEnabled &&
                        loadedEvent.start > new Date().toISOString()
                    "
                > -->
                    <div
                        v-if="
                            loggedUser.id &&
                            loadedEvent.paid &&
                            loadedEvent.public &&
                            loadedEvent.seatsTaken === loadedEvent.seats &&
                            loadedEvent.start > new Date().toISOString()
                        "
                    >
                        <div
                            class="mb-6 link-box is-size-5 is-subtle is-uppercase has-text-weight-bold"
                        >
                            sold out
                        </div>
                    </div>
                </div>
                <p
                    v-html="loadedEvent.summary"
                    class="my-3 has-text-link has-text-weight-normal parsed-paragraph"
                ></p>

                <PaypalCheckout
                    v-if="
                        alreadyHasTicket === false &&
                        getMatchingMembership().id &&
                        loadedEvent.paid &&
                        loadedEvent.public &&
                        loadedEvent.seatsTaken < loadedEvent.seats &&
                        loadedEvent.start > new Date().toISOString()
                    "
                    v-model="selectedQty"
                    :transactionName="loadedEvent.title"
                    :itemAmount="loadedEvent.price"
                    :eventDay="loadedEvent.selectedDay"
                    :eventStart="loadedEvent.startString"
                    :multiBuy="loadedEvent.multiBuy"
                    :seatsTaken="loadedEvent.seatsTaken"
                    :totalSeats="loadedEvent.seats"
                    :eventId="loadedEvent.id"
                    :userId="loggedUser.id"
                    :membershipId="getMatchingMembership().id"
                />
                <div
                    class="card grid-item-lg"
                    v-if="
                        !loggedUser.id &&
                        loadedEvent.paid &&
                        loadedEvent.public &&
                        loadedEvent.seatsTaken < loadedEvent.seats &&
                        loadedEvent.start > new Date().toISOString()
                    "
                >
                    <div class="card-content">
                        <div
                            class="is-size-3 mb-3 is-primary has-text-weight-bold"
                        >
                            {{ $t("event.logintobuy") }}
                        </div>
                        <div class="wrapper-box is-size-5 is-primary">
                            {{ $t("event.mustbelogged") }}

                            <div class="login-hint mt-2">
                                <nuxt-link :to="localePath('/u/register')">
                                    <b-button
                                        class="mr-1 is-uppercase is-size-5 primary-btn self-end"
                                    >
                                        {{ $t("login.register") }}
                                    </b-button></nuxt-link
                                >
                                &nbsp;{{ $t("event.or") }}&nbsp;
                                <nuxt-link :to="localePath('/u/login')">
                                    <b-button
                                        class="ml-1 is-uppercase is-size-5 primary-btn self-end"
                                    >
                                        {{ $t("register.login") }}
                                    </b-button></nuxt-link
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="card grid-item-lg"
                    v-if="
                        loggedUser.id &&
                        !alreadyHasTicket &&
                        !getMatchingMembership().id &&
                        loadedEvent.paid &&
                        loadedEvent.public &&
                        loadedEvent.seatsTaken < loadedEvent.seats &&
                        loadedEvent.start > new Date().toISOString()
                    "
                >
                    <div class="card-content">
                        <div class="grid-item-lg">
                            <div
                                class="is-size-3 mb-3 has-text-warning has-text-weight-bold is-flex-start"
                            >
                                <b-icon
                                    icon="fas fa-ticket-alt"
                                    class="ml-3 mr-5 mb-1"
                                />
                                {{ $t("event.getmembership") }}
                            </div>
                            <div class="wrapper-box is-subtle">
                                <div class="login-hint">
                                    <span class="">
                                        {{ $t("event.gotomembership") }}
                                        <span
                                            class="is-size-6 is-uppercase is-primary-alt has-text-weight-bold"
                                        >
                                            {{
                                                this.$i18n.locale === "it"
                                                    ? loadedEvent.category.name
                                                    : loadedEvent.category
                                                          .nameEn
                                            }}</span
                                        >
                                        {{ $t("event.gotomembership2") }}
                                        <nuxt-link
                                            class="is-inline-link is-primary-alt is-size-6 has-text-weight-bold mx-0"
                                            :to="localePath('/u/membership')"
                                        >
                                            {{
                                                $t("event.membership")
                                            }} </nuxt-link
                                        >.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="card grid-item-lg"
                    v-if="
                        alreadyHasTicket &&
                        getMatchingMembership().id &&
                        loadedEvent.paid &&
                        loadedEvent.public &&
                        loadedEvent.seatsTaken < loadedEvent.seats &&
                        loadedEvent.start > new Date().toISOString()
                    "
                >
                    <div class="card-content">
                        <div class="grid-item-lg">
                            <div
                                class="is-size-3 mb-3 has-text-success has-text-weight-bold is-flex-start"
                            >
                                <b-icon
                                    icon="fas fa-check"
                                    class="ml-3 mr-5 mb-1"
                                />
                                {{ $t("event.alreadybought") }}
                            </div>
                            <div class="wrapper-box is-subtle">
                                <div class="login-hint">
                                    <span class="">
                                        {{ $t("event.gotoprofile") }}
                                        <nuxt-link
                                            class="is-inline-link is-primary-alt is-size-6 has-text-weight-bold mx-0"
                                            :to="localePath('/u')"
                                        >
                                            {{
                                                $t("event.profile")
                                            }} </nuxt-link
                                        >.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <GridBox class="mt-5" v-if="nextUp && nextUp.length > 0">
                    <GridItem
                        size="100%"
                        height="auto"
                        :colidx="3"
                        transparent
                        class="m-0 p-0"
                    >
                        <h3
                            class="is-size-6 is-primary is-uppercase has-text-weight-bold"
                        >
                            {{ $t("event.relatedEvents") }}
                            {{
                                this.$i18n.locale === "it"
                                    ? loadedEvent?.category?.name
                                    : loadedEvent?.category?.nameEn
                            }}
                        </h3>
                    </GridItem>
                    <EventCard
                        :hasDay="true"
                        v-for="event in nextUp"
                        :key="event.id"
                        :loaded="event ? true : false"
                        :event="event"
                        :col="2"
                        height="auto"
                        :clickevt="openEvt"
                        :seatsOptions="seatsOptions"
                        :onReady="onReady"
                    />
                </GridBox>
            </GridBody>
        </GridItem>
    </GridBox>
</template>
<style lang="scss" scoped>
.card {
    background: rgba(var(--bg-secondary-rgba), 0.6) !important;
    backdrop-filter: blur(2rem);
    border-radius: var(--radius-sm);
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    line-height: initial;
}
.grid-body {
    margin: 0;
}
.img-card {
    @media screen and (min-width: 1280px) {
        top: 5rem;
        position: sticky !important;
    }

    z-index: 10;
}
.twocol-grid-box {
    /* width: 100% !important; */
    /* min-width: 100% !important; */
    // height: auto !important;
    display: grid;
    grid-gap: 1rem;
    padding-bottom: 1rem;
    /* padding: 0; */
    grid-template-columns: repeat(3, minmax(200px, 410px));
    grid-template-rows: auto !important;
    /* justify-items: center;
    align-items: center; */
    justify-content: center;
    align-content: center;
    /* max-width: 1280px !important; */
    @media screen and (max-width: 1280px) {
        display: grid;
        grid-template-columns: repeat(1, minmax(350px, 1fr));
        grid-template-rows: auto !important;
    }
}

.content-card {
    justify-content: flex-start;
    padding: 1rem;
    @media screen and (min-width: 1280px) {
        padding-top: 2.5rem;
        padding-right: 1rem;
    }
    background: none;
    /* width: 100%; */
    /* padding: 0; */
    /* margin: 0; */
}
.gradient-overlay {
    transition: all 0.2s ease-in-out;
    opacity: 0.5;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    overflow: hidden;
    height: 90vh;
    width: 100%;
    /* background: red; */
}
.img-overlay {
    transition: all 0.2s ease-in-out;
    filter: blur(0.5rem) grayscale(0.5) brightness(0.4) contrast(1.3);
    mask-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 15%,
        rgba(0, 0, 0, 0.9) 100%
    );
    opacity: 0.6;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    width: 100%;
    overflow: hidden;
    height: 90vh;
    width: 100%;
    /* background: red; */
}
.is-self-start {
    align-self: flex-start;
    width: auto;
}
.is-self-end {
    align-self: flex-end;
}
.is-small-icon {
    font-size: 1.1rem;
    // margin: 0;
    // padding: 0;
    margin-bottom: 0.2rem;
    line-height: 1.1rem;
}

.is-flex-start {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    line-height: 2rem;
}
.login-hint {
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    font-size: 1.25rem;
    color: var(--color-primary);
    // margin-top: 1rem;
    .is-inline-link {
        display: inline-block;
        width: auto;
        font-size: 1.25rem !important;
    }
}

.is-cat {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    font-size: 1.25rem;
    margin-top: 0 !important;
    padding: 0 !important;
    line-height: 1.25rem;
}
.wrapper-box {
    line-height: 1.5rem;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
}

.parsed-paragraph {
    white-space: pre-line;
    font-size: 1.25rem;
}

.image-lightbox {
    height: 100%;
    // position: relative !important;
    /* min-width: 20%; */
    /* max-width: 20%; */
    width: 100%;
    // max-height: 450px;
    // padding-left: 2rem;
    padding-top: 2rem;
    @media screen and (max-width: 540px) {
        // min-height: 50vh;
        // max-height: 80vh;
        margin-top: 1rem;
        padding: 0 1rem 0 1rem;
    }
    @media screen and (max-width: 1280px) and (min-width: 540px) {
        // min-height: 50vh;
        // max-height: 80vh;
        margin-top: 1rem;
        padding: 0 0 0 1rem;
    }
    max-width: 100%;
    /* }./ */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}
.event-image {
    /* object-fit: contain; */
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;

    overflow: hidden !important;
    border-radius: var(--radius-xs) !important;
    /* box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.1); */
    /* @media screen and (max-width: 767px) {
        width: 100%;
        // border-radius: 0;
    } */
    height: auto;

    @media (max-width: 1280px) {
        height: auto;
        max-height: 50vh;
    }
    @media (max-width: 1280px) {
        height: auto;
        max-height: 50vh;
    }
    .img-hero {
        // transform: scale(1.02);
        // overflow: hidden;
        width: 100%;
        height: 100%;
        margin: 0;
        @media (max-width: 1280px) {
            border-radius: var(--radius-xs) !important;
        }
        @media (max-width: 1280px) {
            border-radius: var(--radius-xs) !important;
        }
        padding: 0;
        object-fit: cover;
        border-radius: var(--radius-xs) !important;
    }
}

.header {
    // min-height: 5rem;
    // width: 100%;
    /* margin-top: 0.5rem; */
    // margin-top: 1rem;
    display: flex;
    width: 100%;
    flex-direction: column;
    height: auto;
    // margin: 0.5em 1em;
    // flex-wrap: nowrap;
    justify-content: flex-start;
    .title-span {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        // margin-bottom: 1rem;
    }
}
.flex-between {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 0;
    @media screen and (max-width: 767px) {
        flex-direction: column;
        align-items: flex-start;
    }
    // height: 100px;
    // margin-bottom: 1rem;
}
.total-indicator {
    // background:
    padding: 0.5rem 1rem 0.3rem 1rem;
    border-radius: 1rem;
    width: auto;
    display: flex;
    flex-direction: row;
    // height: 100
    margin-top: 0;
    align-items: center;
    justify-content: flex-end;
    line-height: 1.25rem;
    // dont wrap text
    white-space: nowrap;
    &.is-indicator-success {
        background: rgba(var(--color-success-rgba), 0.35);
    }
    &.is-indicator-error {
        background: rgba(var(--color-danger-rgba), 0.35);
    }
    @media screen and (max-width: 767px) {
        margin-top: 0.5rem;
    }
    // width: 100%;
}
.flexstart-icon {
    width: auto !important;
}

.is-event-label {
    margin-top: 0.5rem;
    width: 24px;
    height: 24px;
    // min-width: 24px;
    // min-height: 24px;
    aspect-ratio: 1;
    // max-height: 100%;
    // display: flex;
    // flex-direction: row;
    // margin: 0;
    padding: 0;
    border-radius: 5rem;
    margin-right: 0.5em;
}

.link-box {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
}

@keyframes appear {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
<script>
const GET_SINGLE_EVENT = `
  query getEvent($id: EventoWhereUniqueInput!) {
    Evento(where: $id) {
      id
      title
      start
      end
      summary
      backgroundColor
      link
      urlSlug
      allDay
      recurring
      daysOfWeek
      startRecur
      endRecur
      display
      image
      paid
      public
      seatsTaken
      seats
      price
      currency
      createdAt
      multiBuy
      category{
        name
        nameEn
        value
        id
      }
    }
  }
`;
const GET_EVENTS = `
  query getEvents($first: Int, $skip: Int, $start_gte: DateTime, $end_lte: DateTime, $category: TipoditesseramentoWhereInput, $id_not: ID!) {
    allEventi(
            sortBy: start_ASC,
            first: $first,
            skip: $skip,
            where: {
                start_gte: $start_gte,
                end_lte: $end_lte,
                category: $category,
                id_not: $id_not
            }
        )  {
      id
      title
      start
      end
      summary
      backgroundColor
      link
      urlSlug
      allDay
      recurring
      daysOfWeek
      startRecur
      paid
      seats
      seatsTaken
      endRecur
      display
      image
      featured
      category{
        name
        nameEn
        value
        id
      }
    }
  }
`;

const CHECK_USER = `
    query check {
        authenticatedPublicUtente {
            id
            email
            firstName
            lastName
            active
            memberships {
                valid
                id
                nationalId
                fiscalCode
                dob
                address
                createdAt
                acceptsMarketing
                expires
                citizenship
                city
                country
                type {
                    id
				    name
                    nameEn
                    value
			    }
            }
        }
    }
`;
function graphql(query, variables = {}) {
    return fetch(
        process.env.NODE_ENV === "production"
            ? "https://www.tempiodelfuturo.art/admin/api"
            : "http://localhost:3000/admin/api",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                variables,
                query,
            }),
        }
    ).then(function (result) {
        return result.json();
    });
}

import PaypalCheckout from "~/components/payment/PaypalCheckout.vue";
import ICountUp from "vue-countup-v2";
import EventCard from "~/components/EventCard";
import GridBox from "~/components/GridBox";
import GridItem from "~/components/GridItem";
import GridBody from "~/components/GridBody";

export default {
    name: "SingleEvent",
    data() {
        return {
            actualImage: "",
            seatsOptions: {
                decimalPlaces: 0,
                duration: 0.5,
                useEasing: true,
                useGrouping: true,
                // separator: ",",
                // decimal: ".",
                // prefix: `${this.currency} `,
                suffix: "",
            },
            pageTitle: "TEMPIO DEL FUTURO *PERDUTO",
            loadedEvent: {},
            isLoadingData: false,
            selectedQty: 1,
            loggedUser: {},
            alreadyHasTicket: false,
            nextUp: [],
        };
    },
    layout: "default",
    components: {
        PaypalCheckout,
        ICountUp,
        EventCard,
        GridBox,
        GridItem,
        GridBody,
    },
    // beforeMount() {
    // },
    mounted() {
        this.$fetch();
        window.addEventListener("resize", () => {
            this.$forceUpdate();
        });
        this.enterAnimation();
    },
    head() {
        return {
            title: `${this.pageTitle}`,
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.loadedEvent.descriptionForSeo,
                },

                {
                    hid: "og:title",
                    property: "og:title",
                    content: this.loadedEvent.titleForSeo,
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.loadedEvent.descriptionForSeo,
                },
                {
                    hid: "og:image",
                    property: "og:image",
                    content: `${this.loadedEvent.ogImage}`,
                },
                {
                    hid: "og:image:alt",
                    property: "og:image:alt",
                    content: "",
                },
                // {
                //     hid: "og:image:height",
                //     property: "og:image:height",
                //     content: "900px",
                // },
                // {
                //     hid: "og:image:width",
                //     property: "og:image:width",
                //     content: "900px",
                // },
                {
                    hid: "og:url",
                    property: "og:url",
                    content: `${this.$config.baseUrl}/event/${this.loadedEvent.id}`,
                },
                {
                    hid: "og:type",
                    property: "og:type",
                    content: "website",
                },
                {
                    hid: "og:site_name",
                    property: "og:site_name",
                    content: "TEMPIO DEL FUTURO *PERDUTO",
                },
                {
                    hid: "og:locale",
                    property: "og:locale",
                    content: this.$i18n.locale,
                },
                {
                    hid: "og:locale:alternate",
                    property: "og:locale:alternate",
                    content: "en_US",
                },
                {
                    hid: "og:locale:alternate",
                    property: "og:locale:alternate",
                    content: "it_IT",
                },
                // twitter large card
                {
                    hid: "twitter:card",
                    name: "twitter:card",
                    content: "summary_large_image",
                },
                {
                    hid: "twitter:site",
                    name: "twitter:site",
                    content: "@tdfp",
                },
                {
                    hid: "twitter:creator",
                    name: "twitter:creator",
                    content: "@tdfp",
                },
                {
                    hid: "twitter:title",
                    name: "twitter:title",
                    content: this.loadedEvent.titleForSeo,
                },
                {
                    hid: "twitter:description",
                    name: "twitter:description",
                    content: this.loadedEvent.descriptionForSeo,
                },
                {
                    hid: "twitter:image",
                    name: "twitter:image",
                    content: `${this.loadedEvent.ogImage}`,
                },
            ],
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.prevRoute = from;
            // console.log(from);
        });
    },

    async fetch() {
        this.isLoadingData = true;
        try {
            // console.log(this.$router.currentRoute);
            if (this.$store.getters["public-auth/authedUser"].id) {
                const { data } = await graphql(CHECK_USER);

                if (data && data.authenticatedPublicUtente) {
                    if (data.authenticatedPublicUtente.active) {
                        this.loggedUser = data.authenticatedPublicUtente;
                        this.$store.commit(
                            "public-auth/SET_USER",
                            {
                                id: data.authenticatedPublicUtente.id,
                                email: data.authenticatedPublicUtente.email,
                                firstName:
                                    data.authenticatedPublicUtente.firstName,
                                lastName:
                                    data.authenticatedPublicUtente.lastName,
                            }
                            // { root: true }
                        );
                    } else {
                        this.$store.dispatch("setLoggedIn", false);
                    }
                } else {
                    this.$store.dispatch("setLoggedIn", false);
                }
            }
            let { data } = await graphql(GET_SINGLE_EVENT, {
                // id: { id: this.eventProps.id },
                id: { id: this.$router.currentRoute.params.id },
            });

            this.loadedEvent = data.Evento;
            let { data: nextupData } = await graphql(GET_EVENTS, {
                // first: this.firstVal,
                // skip: this.skipVal,
                // not this event
                id_not: this.loadedEvent.id,
                category: { id: this.loadedEvent.category.id },
                start_gte: new Date().toISOString(),
                first: 3,
                skip: 0,
            });
            const tickets = await this.$axios.$post(
                process.env.NODE_ENV === "production"
                    ? "https://www.tempiodelfuturo.art/api/tickets"
                    : "http://localhost:3000/api/tickets",
                {
                    // headers: { Authorization: `Bearer ${token}` },
                    id: this.$store.getters["public-auth/authedUser"].id,
                }
            );
            if (nextupData && nextupData.allEventi) {
                this.nextUp = nextupData.allEventi;
                const hexToRgbCard = (hex) => {
                    const hexToRgb = (h) => {
                        let r = 0,
                            g = 0,
                            b = 0;

                        // 3 digits
                        if (h.length === 4) {
                            r = "0x" + h[1] + h[1];
                            g = "0x" + h[2] + h[2];
                            b = "0x" + h[3] + h[3];
                            // 6 digits
                        } else if (h.length === 7) {
                            r = "0x" + h[1] + h[2];
                            g = "0x" + h[3] + h[4];
                            b = "0x" + h[5] + h[6];
                        }
                        return `rgba(${+r}, ${+g}, ${+b}, 0.6)`;
                    };
                    return hexToRgb(hex);
                };
                nextupData.allEventi.forEach((event) => {
                    if (event.image) {
                        const imageId = event.image
                            .split("/")
                            .pop()
                            .split(".")[0];
                        const cloudinaryId = "dwiebcqwl";
                        const actualImage = `https://res.cloudinary.com/${cloudinaryId}/image/upload/c_scale,f_auto,w_200/events/${imageId}.webp`;

                        event.image = actualImage;
                    } else {
                        event.image = null;
                    }
                    event.rgba = hexToRgbCard(event.backgroundColor);
                    event.startString = `H${new Date(
                        event.start
                    ).toLocaleTimeString(this.$i18n.locale, {
                        hour: "2-digit",
                        minute: "2-digit",
                    })}`;
                    if (event.end) {
                        event.endString = new Date(
                            event.end
                        ).toLocaleTimeString(this.$i18n.locale, {
                            hour: "2-digit",
                            minute: "2-digit",
                        });
                    }
                    // event.endString = new Date(event.end).toLocaleTimeString(
                    //     this.$i18n.locale,
                    //     {
                    //         hour: "2-digit",
                    //         minute: "2-digit",
                    //     }
                    // );
                    event.selectedDay = new Date(
                        event.start
                    ).toLocaleDateString(this.$i18n.locale, {
                        weekday: "short",
                        day: "numeric",
                        month: "short",
                    });
                    if (event.end) {
                        event.selectedEndDay = new Date(
                            event.end
                        ).toLocaleDateString(this.$i18n.locale, {
                            weekday: "short",
                            day: "numeric",
                            month: "short",
                        });
                    }
                    // event.selectedEndDay = new Date(
                    //     event.end
                    // ).toLocaleDateString(this.$i18n.locale, {
                    //     weekday: "short",
                    //     day: "numeric",
                    //     month: "short",
                    // });
                });
            }
            // console.log(tickets);
            if (tickets && tickets.length > 0) {
                const ticket = tickets.find((ticket) => {
                    return ticket.event.id === this.loadedEvent.id;
                });
                // console.log(ticket);
                if (ticket) {
                    this.alreadyHasTicket = true;
                }
            }
            if (this.loadedEvent.image) {
                const imageId = this.loadedEvent.image
                    .split("/")
                    .pop()
                    .split(".")[0];
                const cloudinaryId = "dwiebcqwl";
                const actualImage = `https://res.cloudinary.com/${cloudinaryId}/image/upload/c_scale,f_auto,w_350/events/${imageId}.webp`;

                const ogImage = `https://res.cloudinary.com/${cloudinaryId}/image/upload/c_crop,f_auto,w_600,h_315/events/${imageId}.webp`;
                // console.log(ogImage);
                this.loadedEvent.image = actualImage;
                this.loadedEvent.ogImage = ogImage;
            } else {
                this.loadedEvent.image = null;
            }

            this.loadedEvent.startString = `H${new Date(
                this.loadedEvent.start
            ).toLocaleTimeString(this.$i18n.locale, {
                hour: "2-digit",
                minute: "2-digit",
            })}`;
            if (this.loadedEvent.end) {
                this.loadedEvent.endString = new Date(
                    this.loadedEvent.end
                ).toLocaleTimeString(this.$i18n.locale, {
                    hour: "2-digit",
                    minute: "2-digit",
                });
            }
            this.loadedEvent.selectedDay = new Date(
                this.loadedEvent.start
            ).toLocaleDateString(this.$i18n.locale, {
                weekday: "short",
                day: "numeric",
                month: "short",
            });
            if (this.loadedEvent.end) {
                this.loadedEvent.selectedEndDay = new Date(
                    this.loadedEvent.end
                ).toLocaleDateString(this.$i18n.locale, {
                    weekday: "short",
                    day: "numeric",
                    month: "short",
                });
            }
            // this.loadedEvent.selectedEndDay = new Date(
            //     this.loadedEvent.end
            // ).toLocaleDateString(this.$i18n.locale, {
            //     weekday: "short",
            //     day: "numeric",
            //     month: "short",
            // });
            if (
                this.loadedEvent.link &&
                this.loadedEvent.link.startsWith("https://")
            ) {
                this.loadedEvent.actualLink = this.loadedEvent.link;
                this.loadedEvent.linkSlug = new URL(
                    this.loadedEvent.actualLink
                ).origin.slice(8);
            } else if (
                this.loadedEvent.link &&
                this.loadedEvent.link.startsWith("http://")
            ) {
                this.loadedEvent.actualLink = this.loadedEvent.link;
                this.loadedEvent.linkSlug = new URL(
                    this.loadedEvent.actualLink
                ).origin.slice(7);
            } else if (this.loadedEvent.link) {
                this.loadedEvent.actualLink =
                    "https://" + this.loadedEvent.link;
                this.loadedEvent.linkSlug = new URL(
                    this.loadedEvent.actualLink
                ).origin.slice(8);
            }
            const hexToRgbString = (hex) => {
                const hexToRgb = (h) => {
                    let r = 0,
                        g = 0,
                        b = 0;

                    // 3 digits
                    if (h.length === 4) {
                        r = "0x" + h[1] + h[1];
                        g = "0x" + h[2] + h[2];
                        b = "0x" + h[3] + h[3];
                        // 6 digits
                    } else if (h.length === 7) {
                        r = "0x" + h[1] + h[2];
                        g = "0x" + h[3] + h[4];
                        b = "0x" + h[5] + h[6];
                    }
                    return `rgba(${+r}, ${+g}, ${+b}, 0.65)`;
                };
                return hexToRgb(hex);
            };
            this.loadedEvent.rgba = hexToRgbString(
                this.loadedEvent.backgroundColor
            );
            // console.log("loadedevt", this.loadedEvent);
            // update haed title
            // this.pageTitle = "TEMPIO DEL FUTURO *PERDUTO — " + this.$t("event.meta.title");
            this.pageTitle += ` | ${this.loadedEvent.title} \u2013 ${this.loadedEvent.selectedDay} ${this.loadedEvent.startString}`;
            this.$store.commit(
                "setCurrPageTitle",
                `${this.$t("event.header")}: ${this.loadedEvent.title}`
            );
            let trimmedTitle = this.loadedEvent.title;
            if (this.loadedEvent.title.length > 60)
                trimmedTitle = `${trimmedTitle.substring(0, 57)}...`;
            this.loadedEvent.titleForSeo = `${trimmedTitle}`;
            this.loadedEvent.titleForSeo = trimmedTitle.toUpperCase();
            // console.log(this.loadedEvent.titleForSeo);

            this.loadedEvent.descriptionForSeo = `${new Date(
                this.loadedEvent.start
            ).toLocaleString(this.$i18n.locale, {
                // weekday: "numeric",
                day: "numeric",
                month: "numeric",
                minute: "numeric",
                hour: "numeric",
            })} \u00B7 ${this.loadedEvent.summary?.substring(0, 250)}...`;
            // console.log(this.loadedEvent.descriptionForSeo);
        } catch (e) {
            console.error(e);

            this.$router.push({
                path: this.localePath("/404"),
            });
        } finally {
            this.isLoadingData = false;
        }
    },
    watch: {
        $route(to, from) {
            this.$store.commit("setCurrPageTitle", this.$t("events.header"));
        },
    },
    methods: {
        onReady() {
            // this.isLoading = false;
        },
        computeCol(size) {
            // event.featured ? 2 : 1
            // console.log(evt);
            // check if window is present
            if (process.client && window) {
                const width = window.innerWidth;
                if (size === "lg") {
                    if (width > 1560) {
                        return 2;
                    } else if (width > 1280) {
                        return 2;
                    } else if (width > 960) {
                        return 2;
                    } else if (width > 560) {
                        return 2;
                    } else {
                        return 1;
                    }
                } else {
                    if (width > 1560) {
                        return 1;
                    } else if (width > 1280) {
                        return 1;
                    } else if (width > 960) {
                        return 1;
                    } else if (width > 560) {
                        return 1;
                    } else {
                        return 1;
                    }
                }
            } else {
                return 1;
            }
        },
        openEvt(event) {
            this.$router.push({
                path: this.localePath(`/event/${event.id}`),
            });
        },
        openLink(link) {
            window.open(link, "_blank");
        },
        getMatchingMembership() {
            if (
                this.loggedUser &&
                this.loggedUser.id &&
                this.loggedUser.memberships &&
                this.loggedUser.memberships.length > 0 &&
                this.loadedEvent &&
                this.loadedEvent.category &&
                this.loadedEvent.category.id
            ) {
                const validMembership = this.loggedUser.memberships.find(
                    (membership) => {
                        return (
                            membership.valid &&
                            membership.expires > new Date().toISOString() &&
                            membership?.type?.id ===
                                this.loadedEvent?.category?.id
                        );
                    }
                );
                if (validMembership) {
                    // console.log(validMembership);
                    return validMembership;
                } else {
                    // console.log("no valid membership");
                    return false;
                }
            } else {
                // console.log("no membership");
                return false;
            }
        },

        enterAnimation() {
            const anime = this.$anime;

            anime({
                targets: ".twocol-grid-box",
                easing: "easeInOutQuad",
                opacity: [0, 1],
                filter: ["blur(2rem)", "blur(0px)"],
                duration: 360,
            });
        },
    },
};
</script>

